
const Home = () => {
    return (
      <div>
        <div className="container">
          <article>
            <h1>Mofya Ndabala 😎</h1>
            <p>
              I am a self taught full stack web developer.
              <br />
              That is passionate and loves problem solving building cool stuff
              and bring ideas to reality.
            </p>
            <a href="#contact" className="hello-btn">Say Hello 👋</a>
            <a className="works" href="https://docs.google.com/document/d/1-F7EBGKu9q-UjAWuiqZlmWIwn-l8V7dHELPmU9r18Mc/edit">
              Resume ↗
            </a>
          </article>
        </div>
      </div>
    );
}
 
export default Home;